export class SpecAdjustment {
    uniqueId: string;
    category: number;
    vehicleType: number;
    valuationType: number;
    value: number;
    valueType: number;
}



// WEBPACK FOOTER //
// ./src/app/report/adjustments/models/spec-adjustment.model.ts